import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import IVehicleManagementState from './interfaces/vehicle-management-state.d';

export default class VehicleManagementState implements IVehicleManagementState {
    public moduleKeys: string[] = [];

    public extraVehicles: IVehicle[] = [];
}
